function triggerEventOnContainerClick(args, evt) {
  var _a, _b, _c;
  if (evt.button !== 0) {
    return;
  }
  if (evt.target instanceof Element) {
    let currElem = evt.target;
    while (currElem) {
      if (args.ignores.includes(currElem.tagName.toLowerCase())) {
        return;
      }
      currElem = currElem.parentElement;
    }
    const selection = document.getSelection();
    if (selection == null ? void 0 : selection.rangeCount) {
      const range = selection.getRangeAt(0);
      if (range.toString() && (range.commonAncestorContainer === evt.target || evt.target.contains(range.commonAncestorContainer))) {
        return;
      }
    }
  }
  const newEvt = new MouseEvent(evt.nativeEvent.type, evt.nativeEvent);
  const newTarget = (_a = args.ref.current) == null ? void 0 : _a.querySelector(args.triggerSelector);
  const isLink = (newTarget == null ? void 0 : newTarget.tagName) === "A";
  const isNewWindow = (newTarget == null ? void 0 : newTarget.getAttribute("target")) === "_blank" || (newTarget == null ? void 0 : newTarget.getAttribute("download")) !== null || evt.metaKey || evt.ctrlKey;
  if (!isLink || !isNewWindow) {
    newEvt.preventDefault();
  }
  (_c = (_b = args.ref.current) == null ? void 0 : _b.querySelector(args.triggerSelector)) == null ? void 0 : _c.dispatchEvent(newEvt);
}

export { triggerEventOnContainerClick };
//# sourceMappingURL=dom.trigger-event-on-container.js.map
